import React from 'react';
import { connect } from 'react-redux';

import { makeGetTaskProjectColour } from '../../../../../redux/projects/selectors';
import { getProjectColourPalette } from '../../../../../js/helper';

const ConnectedProjectIcon = ({ colour }) => {
  const palette = getProjectColourPalette(colour);
  return (
    <div
      className="h-6 w-6 flex items-center justify-center rounded-md mr-2 flex-shrink-0"
      style={{ background: palette.bg, border: `1px solid ${palette.border}` }}
    >
      <img
        src={`/images/icons/board.svg`}
        style={{ height: '13px', width: '13px', filter: 'brightness(0) saturate(100%)', opacity: 0.55 }}
        alt="icon"
      />
    </div>
  );
};

const makeMapStateToProps = () => {
  const getTaskProjectColour = makeGetTaskProjectColour();
  return (state, props) => ({
    colour: getTaskProjectColour(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedProjectIcon);
